import {Typography, TypographyProps} from "@mui/material";
import React from "react";

export interface DetailsGenericRowProps {
    label: string;
    color?: TypographyProps["color"];
    children?: React.ReactNode;
}

export function DetailsGenericRow(props: Readonly<DetailsGenericRowProps>) {

    return (
        <tr>
            <td width={"30%"}><Typography variant={"body2"}>{props.label}</Typography></td>
            <td>
                {props.children}
            </td>
        </tr>
    );
}